// extracted by mini-css-extract-plugin
export default {"image":"background__image__Wud_Q","color":"background__color__eH0ER","video":"background__video__JPMT6","videoEnabled":"background__videoEnabled__Pir_b"};